import React from 'react'
import styled from 'styled-components'

import { cover } from 'styles/global'

import Wrapper from 'components/Wrapper'
import Section, { SectionBlock } from 'components/Section'
import Heading from 'components/buy/epod2/Heading'
import Device from 'components/buy/epod2/Compare/Device'

const Container = styled.div`
  position: relative;
  overflow-x: hidden;
`

const Content = styled.div`
  position: relative;
  z-index: 1;
`

const Inner = styled.div`
  display: flex;
  justify-content: center;
`

const Background = styled.div`
  background: linear-gradient(90deg, #252525 0%, #151515 50%, #484847 50%, #363636 100%);
  ${cover('absolute')};
`

const Compare = () => (
  <Container>
    <Content>
      <Section>
        <Wrapper>
          <SectionBlock>
            <Heading as="h2">
              COMPARE
              <br />
              <em data-text="AND CONTRAST">AND CONTRAST</em>
            </Heading>
          </SectionBlock>
          <SectionBlock>
            <Inner>
              <Device slug="epod" />
              <Device slug="epod-2" />
            </Inner>
          </SectionBlock>
        </Wrapper>
      </Section>
    </Content>
    <Background />
  </Container>
)

export default Compare
